import React, { ReactNode } from 'react'
import './Indent.scss'

interface Props {
  children: ReactNode
}
export const Indent = ({ children }: Props) => {
  return <div className="cms-indent">{children}</div>
}
